var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    height: 50,
    id: "screenshot-ad6ccafb-79f8-8078-8008-43ff22f3f143",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-ad6ccafb-79f8-8078-8008-43ff22f3f143"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-ad6ccafb-79f8-8078-8008-43ff22f3f143-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-ad6ccafb-79f8-8078-8008-43ff22f3f143-render-1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ad6ccafb-79f8-8078-8008-43ff22f3f143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    className: "frame-background",
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0
    },
    ry: 0,
    rx: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-ad6ccafb-79f8-8078-8008-43ff22f3f144",
    rx: 0,
    ry: 0,
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-ad6ccafb-79f8-8078-8008-43ff22f3f145",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ad6ccafb-79f8-8078-8008-43ff22f3f145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.000030517578125,47.4999885559082C37.426300048828125,47.4999885559082,47.500030517578125,37.4265022277832,47.500030517578125,24.999988555908203C47.500030517578125,12.573474884033203,37.426300048828125,2.499988555908203,25.000030517578125,2.499988555908203C12.573760986328125,2.499988555908203,2.500030517578125,12.573474884033203,2.500030517578125,24.999988555908203C2.500030517578125,37.4265022277832,12.573760986328125,47.4999885559082,25.000030517578125,47.4999885559082Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(53, 56, 75)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-ad6ccafb-79f8-8078-8008-43ff22f3f146",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-ad6ccafb-79f8-8078-8008-43ff22f3f146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.585968017578125,14.793933868408203C23.817901611328125,14.793933868408203,23.242218017578125,14.577869415283203,22.857940673828125,14.145984649658203C22.474151611328125,13.713855743408203,22.281768798828125,13.161853790283203,22.281768798828125,12.489978790283203C22.281768798828125,11.721912384033203,22.509796142578125,11.085926055908203,22.965850830078125,10.582019805908203C23.445831298828125,10.077869415283203,24.093780517578125,9.825916290283203,24.910186767578125,9.825916290283203C25.726104736328125,9.825916290283203,26.326202392578125,10.041980743408203,26.709991455078125,10.473865509033203C27.093780517578125,10.905994415283203,27.286163330078125,11.457996368408203,27.286163330078125,12.129871368408203C27.286163330078125,12.946033477783203,27.045928955078125,13.593982696533203,26.565948486328125,14.073963165283203C26.109893798828125,14.553943634033203,25.461944580078125,14.793933868408203,24.622100830078125,14.793933868408203L24.585968017578125,14.793933868408203ZM23.146026611328125,21.166004180908203L20.410186767578125,20.517810821533203L20.410186767578125,18.609851837158203L25.989776611328125,17.926013946533203L26.062042236328125,17.926013946533203L26.890167236328125,18.573963165283203L26.890167236328125,36.3220100402832L29.770050048828125,36.6098518371582L29.770050048828125,38.3740119934082L20.230010986328125,38.3740119934082L20.230010986328125,36.6098518371582L23.146026611328125,36.2858772277832L23.146026611328125,21.166004180908203Z",
    fillRule: "nonzero",
    style: {
      fill: "rgb(250, 251, 252)",
      fillOpacity: 1
    }
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.33e518272468157891dfa7ebcac12729.svg";
export { ForwardRef as ReactComponent };